import styled, { createGlobalStyle, css } from 'styled-components';
import { Menu as AntDesignMenu } from 'antd';
import { Input } from '../Input/Input.styled';

export const MenuScroll = styled.div.attrs({
  tabIndex: 0,
  role: 'region',
  'aria-label': 'Menu de navegação',
})`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  outline: none;

  &:focus-visible {
    box-shadow: inset 0 0 0 2px #fff;
  }
`;

export const Menu = styled(AntDesignMenu)`
  /* Scroll fica em MenuScroll (scrollable-region-focusable) */
  height: auto !important;
  overflow: visible !important;

  // Adicionando padding no último item do menu
  .ant-menu-item:last-child,
  .ant-menu-submenu:last-child {
    margin-bottom: 24px !important;
    padding-bottom: 24px !important;
  }
`;

const menuTitulo = css`
  font-size: ${({ theme }) => `${14 + 2 * theme.zoomFonte}px`};
  display: inline-block;
  word-wrap: break-word;
  white-space: break-spaces;
  line-height: 1.6;
`;

export const SubMenu = styled(AntDesignMenu.SubMenu)`
  .menu-titulo {
    ${menuTitulo}
  }

  .ant-menu-submenu-arrow {
    display: none;
  }

  .ant-menu-submenu-title {
    padding: 0px 20px;
  }

  .anticon-arrow-right {
    border: 1px solid;
    border-radius: 50%;
    padding: 3px;

    svg {
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }
`;

export const MenuItem = styled(AntDesignMenu.Item)`
  .menu-titulo {
    ${menuTitulo}
  }
`;

/** Campo + label visível (AccessMonitor label_02 / QualWeb T17). */
export const SearchField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 16px;
  flex-shrink: 0;
  gap: 6px;
`;

/** Label acima do input (posição aceita pelo T17 para type=text). */
export const SearchLabel = styled.label`
  color: ${({ theme }) => (theme.highContrast ? '#000000' : '#ffffff')};
  font-size: ${({ theme }) => `${12 + 2 * (theme.zoomFonte || 0)}px`};
  font-weight: 600;
  line-height: 1.3;
`;

/** Input simples (não Search) — allowClear interno; evita lupa sem nome acessível. */
export const SearchMenu = styled(Input)`
  display: flex;
  width: 100%;

  .ant-input-clear-icon {
    color: ${({ theme }) =>
      theme.highContrast ? 'rgba(0, 0, 0, 0.45)' : 'rgba(255, 255, 255, 0.65)'};
    font-size: 14px;
  }

  .ant-input-clear-icon:hover {
    color: ${({ theme }) => (theme.highContrast ? '#000000' : '#ffffff')};
  }
`;

export const MenuStyles = createGlobalStyle`

  .ant-menu-title-content, .ant-menu-item-active {
    color: #fff !important;
    text-decoration-color: none !important;
    text-emphasis-color: none !important;
  }

  .ant-menu-item:hover, .ant-menu-submenu-open {
        text-decoration: underline;
  }

  .ant-menu-dark .ant-menu-inline. ant-menu-sub {
    box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.45);
  }

  .ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title{
    line-height:normal;
    height:auto;
    margin: 12px 0px;
    text-wrap: auto;
  }

  .ant-menu-inline-collapsed-tooltip { 
    display: none;
  }

  .ant-tooltip .ant-tooltip-inner,
  .ant-tooltip .ant-tooltip-arrow-content {
    background-color: #262626;
    color: #fff;
  }
`;
